var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":function($event){_vm.$emit('next')}}},[_vm._v("\n    "+_vm._s(_vm.$t("formFields.nextButton.label"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }